import { defineMessages } from 'react-intl';

export default defineMessages({
  claimNumber: {
    id: 'claims.claim_number',
  },
  client: {
    id: 'claims.client',
  },
  lossDate: {
    id: 'claims.loss_date',
  },
  openingDate: {
    id: 'claims.opening_date',
  },
  numberOfVictim: {
    id: 'claims.number_of_victim',
  },
  preOpeningDate: {
    id: 'claims.preopening_date',
  },
  title: {
    id: 'pending_claims.title',
  },
  lossHour: {
    id: 'claims.loss_hour',
  },
  claimPlace: {
    id: 'claims.claim_place',
  },
  registrationNumber: {
    id: 'claims.registration_number',
  },
  linesPerPage: {
    id: 'lines_per_page',
  },
  policyNumber: {
    id: 'claim_declaration.police_number',
  },
});
